import { useGridApiRef } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { AgButton } from 'src/components/ui';
import useGridExport from 'src/hooks/useGridExport';
import { DataGrid, GridToolbarV2, useGridRows } from 'src/modules/grids';
import { useCreatePricingSheet } from '../hooks/useCreatePricingSheet';
import usePricingSheetsColumns from '../hooks/usePricingSheetsColumns';
import { PRICING_SHEETS_GRID_STORAGE_KEY, usePricingSheetsPage } from '../hooks/usePricingSheetsPage';

export default function PricingSheets() {
  const apiRef = useGridApiRef();
  const columns = usePricingSheetsColumns();
  const enhancedGridState = useGridRows({ mode: 'paged', storageKey: PRICING_SHEETS_GRID_STORAGE_KEY });
  const { rows, loading, pageInfo, totalCount, fetchAllForExport, reader } = usePricingSheetsPage(enhancedGridState);
  useGridExport(apiRef, 'pricing-sheets', undefined, undefined, fetchAllForExport);
  const { create: createNewPricingSheet } = useCreatePricingSheet();

  const toolbar = useMemo(
    () => (
      <GridToolbarV2
        apiRef={apiRef}
        enhancedGridState={enhancedGridState}
        entityName="Pricing Sheet"
        entityNamePlural="Pricing Sheets"
        toolbarActionsRight={
          <AgButton variant="primary" onPress={createNewPricingSheet}>
            Add Pricing Sheet
          </AgButton>
        }
      />
    ),
    [apiRef, enhancedGridState, createNewPricingSheet]
  );

  return (
    <>
      {reader}
      <DataGrid
        mode="paged"
        rows={rows}
        totalCount={totalCount}
        pageInfo={pageInfo}
        loading={loading}
        enhancedGridState={enhancedGridState}
        columns={columns}
        gridKey="settings.business.pricing-sheets"
        storageKey={PRICING_SHEETS_GRID_STORAGE_KEY}
        apiRef={apiRef}
        slots={{ toolbar }}
        variant="list"
      />
    </>
  );
}
